import JsonLd from '@/components/JsonLd'
import { serviceSchema, breadcrumbSchema } from '@/lib/jsonLdSchemas'
import Navbar from '@/components/layout/Navbar'
import Footer from '@/components/layout/Footer'
import GrowthHero from '@/components/sections/growth/GrowthHero'
import GrowthChannels from '@/components/sections/growth/GrowthChannels'
import GrowthPricing from '@/components/sections/growth/GrowthPricing'
import GrowthContact from '@/components/sections/growth/GrowthContact'
import ServiceNav from '@/components/sections/ServiceNav'

export default function Growth() {
  return (
    <div className="min-h-screen bg-background font-sans text-foreground selection:bg-accent selection:text-white">
      <JsonLd data={serviceSchema({ name: 'Performance Marketing', description: 'Acquisition systems designed for compounding returns. PPC, Social, and Email channels with a focus on CAC and LTV.', path: '/growth' })} />
      <JsonLd data={breadcrumbSchema([{ name: 'Services', path: '/#services' }, { name: 'Growth', path: '/growth' }])} />
      <Navbar />
      <main>
        <GrowthHero />
        <GrowthChannels />
        <GrowthPricing />
        <GrowthContact />
        <ServiceNav />
      </main>
      <Footer />
    </div>
  )
}
